export enum TestID {
  GenerateButton = 'pin-panel-generate-btn',
  CopyButton = 'pin-panel-copy-btn',
}
